var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMicrophoneOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#F5222D",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2.5,
    width: 6,
    height: 9.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5a5.5 5.5 0 0 0 11 0M10 15v3M7.5 18h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 3 14 14",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrophoneOff);
export default __webpack_public_path__ + "static/media/ic_microphone_off.09c4e03e17c05b405963c1a5ff9f863f.svg";
export { ForwardRef as ReactComponent };